module.exports = __webpack_public_path__ + "static/media/polar-software-meeting027.ae582899.jpg";